var map = {
	"./menu": "fb1f",
	"./menu.json": "fb1f",
	"./slider_header": "75a0",
	"./slider_header.json": "75a0",
	"./widget_brands": "a612",
	"./widget_brands.json": "a612",
	"./widget_catalog": "a072",
	"./widget_catalog.json": "a072"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fbc9";